import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackPageView = (pageName, properties = {}) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    page: pageName,
    ...properties,
    ...getEnvironmentData()
  };
  
  posthog.capture('$pageview', eventData);
  track('pageview', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_name: pageName,
      content_type: 'product',
      content_id: `page_${pageName}`
    });
  }
}; 